import { render, staticRenderFns } from "./regis_normal.vue?vue&type=template&id=b0d470a6&scoped=true"
import script from "./regis_normal.vue?vue&type=script&lang=js"
export * from "./regis_normal.vue?vue&type=script&lang=js"
import style0 from "./regis_normal.vue?vue&type=style&index=0&id=b0d470a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0d470a6",
  null
  
)

export default component.exports